import classNames from 'classnames';
import React from 'react';
import ShareButton from '../../platformui/Buttons/ShareButton';
import withKeepTabFocus from '../../platformui/Containers/withKeepTabFocus';
import useWindowLocationHref from '../../platformui/Hooks/useWindowLocation';
import LetterSlide from '../c-letter-slides';

const LetterSlideModal = ({
  randomBackground,
  currentIndex,
  mainContent,
  popoverBtnText,
  popoverText,
  letterData,
  setLetterData,
  updateLetterData,
  finalLetterKey,
  handleOnClickClose,
  prevSlide,
  nextSlide,
  backBtnText,
  nextBtnText,
  shareButton,
}) => {
  const finalDataToShare = `${finalLetterKey}-${mainContent?.[currentIndex]?.BlockId}`;
  const href = useWindowLocationHref();
  return (
    <div className="letter-slides__modal-overlay">
      <div
        role="dialog"
        className={classNames({
          'letter-slides__modal-content': true,
          [`letter-slides__modal-content--gradient-${randomBackground}`]: true,
          'letter-slides__modal-content--gradient-5':
            currentIndex === mainContent?.length - 1,
        })}
      >
        <div className="letter-slides__modal-content__top">
          <div className="letter-slides__pagination">
            {currentIndex + 1} av {mainContent?.length}
          </div>
          <button
            aria-label="stäng dialogruta"
            className="letter-slides__close-modal"
            onClick={handleOnClickClose}
          />
        </div>
        <div className="letter-slides__modal-content__inner">
          <LetterSlide
            content={mainContent?.[currentIndex]}
            popoverBtnText={popoverBtnText}
            popoverText={popoverText}
            letterData={letterData}
            setLetterData={setLetterData}
            updateLetterData={updateLetterData}
            finalOutputKey={finalLetterKey}
          />
        </div>
        <nav
          className={classNames({
            'letter-slides__modal-content__bottom': true,
            'letter-slides__modal-content__bottom--first': currentIndex === 0,
            'letter-slides__modal-content__bottom--last':
              currentIndex === mainContent?.length - 1,
          })}
        >
          <button
            className="button button--secondary"
            onClick={prevSlide}
            disabled={currentIndex === 0}
            aria-disabled={currentIndex === 0}
            aria-label={currentIndex === 0 ? '' : `Gå till föregående sida`}
            data-event-category={href || 'novalue'}
            data-event-action="ModalBlocket"
            data-event-name={`${
              parseInt(currentIndex) + 1
            } Gå till föregående sida`}
            data-event-value={currentIndex}
          >
            {backBtnText}
          </button>
          {currentIndex === mainContent?.length - 1 ? (
            shareButton && (
              <ShareButton
                description={letterData[finalDataToShare]?.value}
                buttonText={shareButton.ShareButtonText}
                title={shareButton.ShareTitle}
                requireLink={false}
                copiedToClipboardMessage={'Texten blev kopierad'}
                trackCategory={href || 'novalue'}
                trackName={`${parseInt(currentIndex) + 1} ${
                  shareButton.ShareButtonText
                }`}
                trackAction={'ModalBlocket'}
              />
            )
          ) : (
            <button
              className="button button--primary"
              onClick={nextSlide}
              disabled={currentIndex === mainContent?.length - 1}
              aria-disabled={currentIndex === mainContent?.length - 1}
              aria-label={
                currentIndex === mainContent?.length - 1
                  ? ''
                  : `Gå till nästa sida`
              }
              data-event-category={href || 'novalue'}
              data-event-action="ModalBlocket"
              data-event-name={`${
                parseInt(currentIndex) + 1
              } Gå till nästa sida`}
              data-event-value={currentIndex}
            >
              {nextBtnText}
            </button>
          )}
        </nav>
      </div>
    </div>
  );
};

export default withKeepTabFocus(LetterSlideModal);
